export default __webpack_public_path__ + "static/media/December_00.227c8f41.png";